import React from 'react';
import PropTypes from 'prop-types';
import ChargeModalButton from './ChargeModalButton';
import insertCcImage from '../../../../../images/insert-cc.svg';

const ReaderlessChargeButton = ({ onClick, disabled }) => (
  <ChargeModalButton onClick={onClick} disabled={disabled} image={insertCcImage}>
    Third Party POS
    <p className="o-wrapper u-pt zeta u-co-gray u-max-width-360">
      Clicking 3rd party POS will not process the payment. To process a card
      payment either use the 3rd party POS system or click Card Entry below to
      key in the card info.
    </p>
  </ChargeModalButton>
);
ReaderlessChargeButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default ReaderlessChargeButton;
